import {
  Select,
  SelectContent,
  SelectGroup,
  SelectTrigger,
  SelectItem,
} from '@e2n/ui';
import {
  getWiederholungStringFromTerminWiederholung,
  TerminWiederholung,
} from '@/domain/termine/shared/types/TerminWiederholung';

export default function RepetitionInterval({
  value,
  onChange,
}: {
  value: TerminWiederholung;
  onChange: (value: TerminWiederholung) => void;
}) {
  return (
    <>
      <div className="pb-3 h-10">
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger className="border-neutrals-300 w-full">
            <div>{getWiederholungStringFromTerminWiederholung(value)}</div>
          </SelectTrigger>
          <SelectContent className="border-none overflow-visible">
            <SelectGroup>
              {Object.values(TerminWiederholung).map((enumValue) => (
                <SelectItem key={enumValue} value={enumValue}>
                  {getWiederholungStringFromTerminWiederholung(enumValue)}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </>
  );
}
